import React, { createContext, memo, useContext } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import useTheme, { initialState } from './useTheme';

export const ThemeContext = createContext(initialState);

export const useThemeContext = () => useContext(ThemeContext);

interface IProvider {
  children: React.ReactNode;
}

const ThemeProvider = ({ children }: IProvider) => {
  const state = useTheme();

  const { theme } = state;

  return (
    <ThemeContext.Provider value={state}>
      <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

export type { ETheme } from './types';
export type { Theme, ThemeColors } from './themes';
export { themeMap } from './useTheme';

export default memo(ThemeProvider);
